import React from 'react';
import '../styles.css';

const Loading = () => {
  return (
    <div className="loading-map d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h3> Espere por favor</h3>
        <span>Localizando...</span>
      </div>
    </div>
  );
};

export default Loading;
